class ProductArViewer extends HTMLElement {
  connectedCallback() {
    this.modelsElement = document.getElementById(this.dataset.modelsId);
    this.launchButton = this.querySelector('[data-product-ar-launch]');
    this.supportProbe = this.querySelector('[data-shopify-xr]');

    if (!this.modelsElement || !this.launchButton || !this.supportProbe || !window.Shopify?.loadFeatures) {
      return;
    }

    this.setupShopifyXr = this.setupShopifyXr.bind(this);
    this.launchXr = this.launchXr.bind(this);
    this.updateSupport = this.updateSupport.bind(this);

    this.launchButton.addEventListener('click', this.launchXr);
    this.supportObserver = new MutationObserver(this.updateSupport);
    this.supportObserver.observe(this.supportProbe, { attributes: true, attributeFilter: ['data-shopify-xr-hidden'] });

    window.Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXr,
      },
    ]);
  }

  disconnectedCallback() {
    document.removeEventListener('shopify_xr_initialized', this.setupShopifyXr);
    this.launchButton?.removeEventListener('click', this.launchXr);
    this.supportObserver?.disconnect();
  }

  setupShopifyXr() {
    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', this.setupShopifyXr, { once: true });
      return;
    }

    try {
      const models = JSON.parse(this.modelsElement.textContent);

      window.ShopifyXR.addModels(models);
      window.ShopifyXR.setupXRElements();
      this.updateSupport();
    } catch (error) {
      console.warn('Unable to initialize product AR.', error);
    }
  }

  updateSupport() {
    if (!this.supportProbe.hasAttribute('data-shopify-xr-hidden')) {
      this.launchButton.hidden = false;
    }
  }

  launchXr() {
    window.ShopifyXR?.launchXR({
      model3dId: Number(this.dataset.modelId),
      title: this.dataset.title,
    });
  }
}

if (!customElements.get('product-ar-viewer')) {
  customElements.define('product-ar-viewer', ProductArViewer);
}
